import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import { apiService } from '../services/api';
import { useToast } from '../hooks/useToast';
import { useLanguage } from '../contexts/LanguageContext';
import { qubitTranslations } from '../translations/qubit-translations';
import LanguageToggle from './LanguageToggle';
import LoadingSpinner from './LoadingSpinner';

const Header = () => {
  const [isEnrolling, setIsEnrolling] = useState(false);
  const { success, error } = useToast();
  const { language } = useLanguage();
  const t = qubitTranslations[language];

  const handleGetStarted = async () => {
    // Scroll to contact section
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header-nav">
      <div className="container">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-3">
            <img 
              src="/qubit-logo.svg" 
              alt="Qubit Center Logo" 
              className="w-8 h-8 text-primary"
              style={{ filter: 'brightness(0) saturate(100%)' }}
            />
            <span className="heading-3 font-mono">QUBIT CENTER</span>
          </div>
          
          <nav className="hidden md:flex items-center gap-8">
            <a href="#curriculum" className="body-medium hover:text-primary transition-colors">
              {t.curriculum}
            </a>
            <a href="#features" className="body-medium hover:text-primary transition-colors">
              {t.features}
            </a>
            <a href="#testimonials" className="body-medium hover:text-primary transition-colors">
              {t.reviews}
            </a>
            <a href="#contact" className="body-medium hover:text-primary transition-colors">
              {t.contact}
            </a>
          </nav>
          
          <div className="nav-actions">
            <LanguageToggle variant="button" />
            <button 
              onClick={handleGetStarted}
              disabled={isEnrolling}
              className="btn-secondary relative"
            >
              {isEnrolling ? (
                <>
                  <LoadingSpinner size="small" className="mr-2" />
                  Loading...
                </>
              ) : (
                t.getStarted
              )}
            </button>
            <button className="md:hidden p-2">
              <Menu className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;